module.exports = __webpack_public_path__ + "static/media/icon-start-time.8ba72393.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-start-time.svg
// module id = ./src/assets/images/icon-start-time.svg
// module chunks = 0